module.exports = __webpack_public_path__ + "assets/img/icons_question.svg";